"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = exports.Select = exports.InputWrapper = exports.RangeInput = exports.VisualContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
    display:  flex;
    position: relative;
    height: auto;
    padding: 4px;
    background-color: #ffffff;
    border-radius: 0.25rem;
`;
exports.VisualContainer = styled_components_1.default.div `
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 999999;
    pointer-events: none;
    border:  1px solid #ced4da;
    border-radius: 0.25rem;
    ${exports.Container}:focus-within & {
        filter: brightness(98%);
        border-color: rgb(127.5, 189, 255);
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
`;
exports.RangeInput = styled_components_1.default.input `
    color: rgba(var(--cor-tema), 1) !important;
    outline: none;
    padding: 4px 8px;
    border-radius: 0.25rem;
    border: none;
    flex: 1;
    min-width: 0;

    text-align: center; /* Centraliza os números */

    /* Remove setas do input type number */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -moz-appearance: textfield;
`;
exports.InputWrapper = styled_components_1.default.div `
    display: flex;
    flex: ${({ $isDouble }) => ($isDouble ? "1" : "auto")};
    width: ${({ $isDouble }) => ($isDouble ? "100%" : "auto")};
    min-width: 0;
`;
exports.Select = styled_components_1.default.select `
    border: none;
    outline: none;
    padding: 4px 8px;
    width: 100px;
    color: rgba(var(--cor-tema), 1) !important;
`;
exports.ClearButton = styled_components_1.default.button `
    width: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #ffffff;
    color: rgba(var(--cor-tema), 1) !important;
    border: none;
`;
